"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var template = require('./uploadButton.jsx');

var uploadStatuses = require('./uploadStatuses');

var UploadButton = /*#__PURE__*/function (_React$Component) {
  _inherits(UploadButton, _React$Component);

  var _super = _createSuper(UploadButton);

  function UploadButton(props) {
    var _this;

    _classCallCheck(this, UploadButton);

    _this = _super.call(this, props);

    _this.getButtonContent = function () {
      return _this.props.status === uploadStatuses.NONE ? _this.props.buttonContent.beforeUpload : _this.props.buttonContent.afterUpload;
    };

    _this.isStatusNone = function () {
      return _this.props.status === uploadStatuses.NONE;
    };

    _this.isDisabled = function () {
      return _this.props.disabled || _this.props.status === uploadStatuses.IN_PROCESS;
    };

    return _this;
  }

  _createClass(UploadButton, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return UploadButton;
}(React.Component);

UploadButton.displayName = displayNames.UPLOAD_BUTTON;
UploadButton.propTypes = {
  /** The value to be displayed when the upload status is set to UPLOAD_SUCCESS. Usually will be the name of the uploaded file */
  value: PropTypes.string,

  /** Callback function to be triggered when clicking on the button */
  onClick: PropTypes.func.isRequired,

  /** Sets the button to disable mode */
  disabled: PropTypes.bool,

  /** The text/node to be displayed inside the button. */
  buttonContent: PropTypes.shape({
    beforeUpload: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    afterUpload: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
  }),

  /** The status of the upload process */
  status: PropTypes.oneOf(['NONE', 'UPLOAD_SUCCESS', 'UPLOAD_FAILED', 'IN_PROCESS']),

  /** The error message of the upload. Leave empty in case there is no error */
  errorMessage: PropTypes.string,

  /** The message to displayed when the upload status is IN_PROCESS*/
  processMessage: PropTypes.string
};
UploadButton.defaultProps = {
  disabled: false,
  status: uploadStatuses.NONE
};
module.exports = compose(UploadButton);